var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Button, Layer, Loading, LoadingPane, Pane, PaneFooter, Paneset, } from '@folio/stripes/components';
import { TitleManager, useStripes } from '@folio/stripes/core';
import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import CalendarForm, { FORM_ID } from '../forms/CalendarForm/CalendarForm';
var OpType;
(function (OpType) {
    OpType[OpType["CREATE_NEW"] = 0] = "CREATE_NEW";
    OpType[OpType["EDIT"] = 1] = "EDIT";
    OpType[OpType["DUPLICATE"] = 2] = "DUPLICATE";
})(OpType || (OpType = {}));
export function getOpType(initialValue, isEdit) {
    if (initialValue === undefined) {
        return OpType.CREATE_NEW;
    }
    if (isEdit) {
        return OpType.EDIT;
    }
    return OpType.DUPLICATE;
}
export var CreateEditCalendarLayer = function (props) {
    var intl = useIntl();
    var stripes = useStripes();
    var _a = useState(false), isSubmitting = _a[0], setIsSubmitting = _a[1];
    var _b = useState(false), submitAttempted = _b[0], setSubmitAttempted = _b[1];
    var pane = React.createElement(LoadingPane, null);
    if (props.dataRepository.isLoaded()) {
        var opType_1 = getOpType(props.initialValue, props.isEdit);
        pane = (React.createElement(Pane, { paneTitle: getOpType(props.initialValue, props.isEdit) === OpType.EDIT ? (React.createElement(FormattedMessage, { id: "ui-calendar.calendarForm.title.edit" })) : (React.createElement(FormattedMessage, { id: "ui-calendar.calendarForm.title.create" })), defaultWidth: "fill", centerContent: true, onClose: props.onClose, dismissible: true, footer: React.createElement(PaneFooter, { renderStart: React.createElement(Button, { onClick: function () { return props.onClose(); } },
                    React.createElement(FormattedMessage, { id: "stripes-core.button.cancel" })), renderEnd: React.createElement(Button, { disabled: isSubmitting, buttonStyle: "primary", marginBottom0: true, type: "submit", form: FORM_ID, onClick: function () { return setSubmitAttempted(true); } }, isSubmitting ? (React.createElement(Loading, null)) : (React.createElement(FormattedMessage, { id: "stripes-core.button.saveAndClose" }))) }) },
            React.createElement(CalendarForm, { closeParentLayer: props.onClose, setIsSubmitting: setIsSubmitting, submitAttempted: submitAttempted, dataRepository: props.dataRepository, initialValues: props.initialValue, submitter: function (calendar) {
                    var _a;
                    if (opType_1 === OpType.EDIT) {
                        var newCalendar = __assign(__assign({}, calendar), { id: (_a = props.initialValue) === null || _a === void 0 ? void 0 : _a.id });
                        return props.dataRepository.updateCalendar(newCalendar);
                    }
                    else {
                        return props.dataRepository.createCalendar(calendar);
                    }
                } })));
    }
    var pageTitle = intl.formatMessage({ id: 'ui-calendar.meta.titleSettings' }) +
        ' - ' + intl.formatMessage({
        id: getOpType(props.initialValue, props.isEdit) === OpType.EDIT
            ? 'ui-calendar.calendarForm.title.edit'
            : 'ui-calendar.calendarForm.title.create',
    });
    return (React.createElement(TitleManager, { page: pageTitle, stripes: stripes },
        React.createElement(Layer, { contentLabel: intl.formatMessage({
                id: getOpType(props.initialValue, props.isEdit) === OpType.EDIT
                    ? 'ui-calendar.calendarForm.title.edit'
                    : 'ui-calendar.calendarForm.title.create',
            }), isOpen: true },
            React.createElement(Paneset, { isRoot: true }, pane))));
};
export default CreateEditCalendarLayer;
